import { useAuth } from '../context/AuthContext.js';

export function PendingApprovalPage() {
  const { logout } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card" style={{ textAlign: 'center' }}>
        <div className="brand" style={{ justifyContent: 'center', marginBottom: 24 }}>
          <div className="brand-mark" />
          <span className="brand-name">SubFi Pay</span>
        </div>

        <div style={{ marginBottom: 16 }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--amber)" strokeWidth="2" strokeLinecap="round" style={{ width: 48, height: 48, margin: '0 auto 16px' }}>
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 className="login-title" style={{ marginBottom: 8 }}>Account Pending Approval</h1>
        <p className="login-subtitle" style={{ marginBottom: 32, lineHeight: 1.6 }}>
          Your account hasn't been approved yet. A platform admin will grant you access shortly.
        </p>

        <button
          className="btn-sm btn-ghost"
          style={{ padding: '10px 24px', fontSize: 14 }}
          onClick={() => void logout()}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ width: 15, height: 15, verticalAlign: 'middle', marginRight: 6 }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Log Out
        </button>
      </div>
    </div>
  );
}
